













































































import {Component} from "vue-property-decorator";
import {Getter} from "vuex-class";
import SmppConnectionsFilter from "@/components/Settings/SmppConnections/SmppConnectionsFilter.vue"
import {ScrollButton} from "wings-ui-components";
import {SmppConnectionItem} from "@/store/settings/smpp_connections/types";
import BaseItemsPage from "../BaseItemsPage";

@Component({components: {SmppConnectionsFilter, ScrollButton}})
export default class SmppConnections extends BaseItemsPage<SmppConnectionItem> {
  @Getter("smppConnections") smppConnections: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'name',
    'description',
  ];

  getData(): any {
    return this.smppConnections ?? [];
  }
}
